export default "__VITE_ASSET__BlWD2GcE__"